import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { core } from "@/lib/mh";
import { errText , copyText } from "@/lib/http";
import { AuthShell, Field, PrimaryBtn, ErrorNote } from "@/components/mh/AuthShell";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [link, setLink] = useState(null);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const { data } = await core.forgot(email);
      setLink(data.reset_token ? `${window.location.origin}/reset-password/${data.reset_token}` : "");
    } catch (e2) {
      setErr(errText(e2));
    }
  };
  return (
    <AuthShell testId="forgot-page" eyebrow="Password reset" title="Forgot your password?" footer={<Link to="/login" className="underline underline-offset-4">Back to sign in</Link>}>
      {link === null ? (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} testId="forgot-email" />
          <ErrorNote>{err}</ErrorNote>
          <PrimaryBtn type="submit" testId="forgot-submit">Create reset link</PrimaryBtn>
        </form>
      ) : (
        <div className="space-y-3" data-testid="reset-link-box">
          <p className="text-sm text-muted-foreground">If that email has an account, its reset link is below. Email delivery arrives in Phase 2, so copy it for now. It expires in 1 hour.</p>
          {link && <code className="block p-3 rounded-lg bg-white/[0.04] border border-white/10 text-xs break-all" data-testid="reset-link">{link}</code>}
          {link && <PrimaryBtn onClick={() => { copyText(link); toast.success("Link copied"); }} testId="copy-reset-link">Copy link</PrimaryBtn>}
        </div>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await core.reset(token, pw);
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (e2) {
      setErr(errText(e2));
    }
  };
  return (
    <AuthShell testId="reset-page" eyebrow="Password reset" title="Choose a new password">
      <form onSubmit={submit} className="space-y-4">
        <Field label="New password (8+ characters)" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} testId="reset-password" />
        <ErrorNote>{err}</ErrorNote>
        <PrimaryBtn type="submit" testId="reset-submit">Update password</PrimaryBtn>
      </form>
    </AuthShell>
  );
}
